var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAwesomeLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.223,
    height: 22.223,
    viewBox: "0 0 22.223 22.223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin",
    "data-name": "Icon awesome-linkedin",
    d: "M20.635,2.25H1.582A1.594,1.594,0,0,0,0,3.852V22.871a1.594,1.594,0,0,0,1.582,1.6H20.635a1.6,1.6,0,0,0,1.587-1.6V3.852A1.6,1.6,0,0,0,20.635,2.25ZM6.716,21.3H3.423V10.693h3.3V21.3ZM5.07,9.244a1.91,1.91,0,1,1,1.91-1.91,1.911,1.911,0,0,1-1.91,1.91ZM19.063,21.3H15.769V16.139c0-1.23-.025-2.813-1.711-2.813-1.716,0-1.979,1.339-1.979,2.723V21.3H8.785V10.693h3.16v1.448h.045a3.469,3.469,0,0,1,3.12-1.711c3.333,0,3.953,2.2,3.953,5.055Z",
    transform: "translate(0 -2.25)",
    fill: "#72efdb"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwesomeLinkedin);
export default __webpack_public_path__ + "static/media/iconAwesomeLinkedin.fbf4fe2456289a34ec80e90711c24af7.svg";
export { ForwardRef as ReactComponent };